import React from "react"
import { CabinPricePP } from "@cruisen/contract"
import { _t, formatCurrency } from "@cruisen/i18n"
import styles from "./styles.module.scss"

interface PriceDetailsProps {
  pricePP: CabinPricePP
  alignRight?: boolean
}

export const PriceDetails: React.FC<PriceDetailsProps> = ({ pricePP, alignRight = false }) => {
  const rowClass = alignRight ? styles.rowEndAlign : styles.rowEnd

  return (
    <>
      <div className={rowClass}>
        <span className={styles.text}>Estimated at</span>
      </div>
      <div className={rowClass}>
        <span className={`${styles.price} ${styles.textBold}`} data-testid="cruise-price">
          {formatCurrency(pricePP.price, 0, 0)}
        </span>
        <span className={styles.text}>{_t("cruiseSuggestionCard.perPerson")}</span>
      </div>
    </>
  )
}
